import { render, staticRenderFns } from "./PolizasSAForm.vue?vue&type=template&id=1d668ca6&scoped=true&"
import script from "./PolizasSAForm.vue?vue&type=script&lang=js&"
export * from "./PolizasSAForm.vue?vue&type=script&lang=js&"
import style0 from "./PolizasSAForm.vue?vue&type=style&index=0&id=1d668ca6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d668ca6",
  null
  
)

export default component.exports